import { fg } from '@atlaskit/platform-feature-flags';

import {
	isProductKey,
	ProductKeys,
	type ProductKeys1P,
} from '../../../../../common/constants/products';
import { isJiraProduct } from '../../../../../common/utils/product';
import { createMultiSelectFilter } from '../../../../filters/multi-select-filter';

import { confluenceQueryParamsFetcher, confluenceSearchLabels } from './confluence';
import { jiraInitialOptionsFetcher, jiraLookupFetcher, jiraQueryParamFetcher } from './jira';

const getProducts1P = (): ProductKeys1P[] => {
	return [
		ProductKeys.Confluence,
		...(fg('rovo_search_in_jira_t25_fps_filters')
			? [ProductKeys.Jira, ProductKeys.JiraProductDiscovery, ProductKeys.JiraServiceManagement]
			: []),
	];
};

export const filter: Readonly<{
    id: "label";
    type: "single-select" | "multi-select";
    queryParams: {
        key: string;
    };
    products: ProductKeys[];
    universal: boolean;
    customValueFields?: string[];
    withState: (state: unknown, config: import("../../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"label">;
    getInitialState: (config: import("../../../../../common/constants/filters/cloud-config/types").CloudConfig) => import("../../../../../common/constants/filters/select-filter/types").SelectFilterMonad<"label">;
    isCompatible: (filterId?: string) => boolean;
    isSupportCustomValue: boolean;
    isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createMultiSelectFilter({
	id: 'label',
	products: [...getProducts1P()],
	alwaysVisible: false,
	universal: false,
	queryParams: {
		key: 'labels',
		fetcher: async (queryParams, config) => {
			if (
				config.product === ProductKeys.Confluence ||
				config.product === ProductKeys.ConfluenceDC ||
				config.primaryProduct === ProductKeys.Confluence
			) {
				return confluenceQueryParamsFetcher(queryParams, config);
			}

			if (!fg('rovo_search_in_jira_t25_fps_filters')) {
				return [];
			}

			const safePrimaryProduct = isProductKey(config.primaryProduct)
				? config.primaryProduct
				: undefined;
			if (isJiraProduct(config.product) || isJiraProduct(safePrimaryProduct)) {
				return jiraQueryParamFetcher(queryParams, config);
			}

			// Not supported in other products
			return [];
		},
	},
	initialOptions: {
		fetcher: async (config) => {
			if (!fg('rovo_search_in_jira_t25_fps_filters')) {
				return [];
			}

			const safePrimaryProduct = isProductKey(config.primaryProduct)
				? config.primaryProduct
				: undefined;
			if (isJiraProduct(config.product) || isJiraProduct(safePrimaryProduct)) {
				return jiraInitialOptionsFetcher(config);
			}

			return [];
		},
	},
	lookup: {
		fetcher: async (query, config) => {
			if (
				config.product === ProductKeys.Confluence ||
				config.product === ProductKeys.ConfluenceDC ||
				config.primaryProduct === ProductKeys.Confluence
			) {
				return confluenceSearchLabels(query, config);
			}

			if (!fg('rovo_search_in_jira_t25_fps_filters')) {
				return [];
			}

			const safePrimaryProduct = isProductKey(config.primaryProduct)
				? config.primaryProduct
				: undefined;
			if (isJiraProduct(config.product) || isJiraProduct(safePrimaryProduct)) {
				return jiraLookupFetcher(query, config);
			}

			return [];
		},
	},
});
